
import React, { useState, useEffect, useContext } from "react";
import Header from "../components/dashboard/header";
import SideMenu from "./student/SideMenu";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Loader from "../components/loader";
import SessionPopup from "./SessionPopup"
import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import tmdbApi from "../api/tmdbApi";
import Select from 'react-select';

let { lambda, appname } = window.app;

const ViewFellows = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [success, setSuccess] = useState(false);
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [editUser, setEditUser] = useState({ name: '', phone: '', userType: '', status: '', emailid: '' });
    const [permission, setPermission] = useState({});
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);
    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const [pathologist, setPathologist] = useState([]);
    const [module, setmodule] = useState([]);
    const [selectedPathologist, setSelectedPathologist] = useState([]);
    const [selectedModule, setSelectedModule] = useState([]);
    const handlePathologistChange = (selectedOptions) => {
        let tmp = [];
        tmp.push(selectedOptions)
        // assignedPathologists
        setSelectedPathologist(tmp)
    }
    const handlemoduleChange = (selectedOptions) => {
        setSelectedModule(selectedOptions)
    }
    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);

    useEffect(() => {
        if (toastMessage) {
            toast.success(toastMessage, {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage("");
        }
    }, [toastMessage]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getuser();
            getPathologist();
            getmoduleInfo();

        }
        // getManagers();
        //  GetCountries();
        // userActivity();
    }, []);

    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);
        if (!id) {
            navigate("/users")
        }

    };

    const getPathologist = async () => {
        let response = await tmdbApi.getPathologist();
        if (response?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true)
        } else {

            setPathologist(response?.result);
            // console.log("resultttttttttttttttttttttttttttt",response?.result)
        }

    }
    const getmoduleInfo = async () => {
        let response = await tmdbApi.getmoduleInfo();
        if (response?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true)
        } else {

            setmodule(response?.result);
            // console.log("resultttttttttttttttttttttttttttt",response?.result)
        }

    }
    const getuser = (e) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/userInfo?appname=' + appname + '&userid=' + id,
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                }
                else {
                    if (response?.data?.result.length > 0) {
                        setEditUser(response?.data?.result?.[0]);
                        if (response?.data?.result?.[0] && response?.data?.result?.[0]?.permissions) {
                            setPermission(response?.data?.result?.[0]?.permissions)
                        }
                        if (response?.data?.result?.[0] && response?.data?.result?.[0]?.assignedPathologists) {
                            setSelectedPathologist(response?.data?.result?.[0]?.assignedPathologists)
                        }
                    } else {
                        setInvalidContent(true)
                    }
                }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/users')
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log('typeeeeeeeeee', value);
        console.log('nameeeee', name);

        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        if (name === "phoneNumber") {
            const numericValue = value.replace(/\D/g, "").slice(0, 10);
            setEditUser(prev => ({ ...prev, phoneNumber: numericValue }));
            return;
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };



    const handleAddUser = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            createuser();
        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;
        if (editUser?.emailid === undefined || editUser?.emailid?.trim() === "") {
            setEmailError("Please enter Email");
            setTimeout(function () { setEmailError("") }, 3000);
            formIsValid = false;
        }
        const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
        if (regEx.test(editUser?.emailid)) {
            setEmailError("");
            setTimeout(function () { setEmailError("") }, 3000)
        } else if (!regEx.test(editUser?.emailid) && editUser?.emailid !== "") {
            setEmailError("Please Enter Valid Email");
            setTimeout(function () { setEmailError("") }, 3000)
            formIsValid = false;
        }

        if (editUser?.name === undefined || editUser?.name?.trim() === "") {
            setNameError("Please enter Name");
            setTimeout(function () { setNameError("") }, 3000);
            formIsValid = false;
        }
        // const phoneRegex = /^[6-9]\d{9}$/;
        // if (!editUser?.phoneNumber?.trim()) {
        //     setPhoneError("Enter phone number");
        //     formIsValid = false;
        // } else if (!phoneRegex.test(editUser.phoneNumber.trim())) {
        //     setPhoneError("Enter valid 10-digit Indian phone number starting with 6-9");
        //     formIsValid = false;
        // } else {
        //     setPhoneError("");
        // }
        // setTimeout(() => setPhoneError(""), 3000);

        if (editUser?.userType === "") {
            setTypeError("Please select Type");
            setTimeout(function () { setTypeError("") }, 3000);
            formIsValid = false;
        }



        return formIsValid;
    }


    const handleSubmit = () => {
        GetTimeActivity()
        setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {
            "emailid": editUser?.emailid?.trim(),
            "userType": editUser?.userType,
            "name": editUser?.name?.trim(),
            "phoneNumber": editUser?.phoneNumber,
            "status": editUser?.status,
            "assignedPathologists": selectedPathologist
        }



        axios({
            method: 'POST',
            url: lambda + '/updateUser?appname=' + appname + '&userid=' + id + "&token=" + token,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (response?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else if (response?.data?.result === "This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        // setToastMessage("User Details Updated Successfully")
                        setSuccess(true)
                    }
                }

            });
    }


    const handleUpdate = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            handleSubmit();
        }
    }
    console.log('editUser', editUser)
    const createuser = async () => {
        setIsLoading(true)
        const isValid = formvalidation();
        if (!isValid) {
            return false
        }
        // GetTimeActivity()   
        let payload = {}
        payload = {
            "emailid": editUser?.emailid?.trim(),
            "userType": editUser?.userType,
            "name": editUser?.name?.trim(),
            "phoneNumber": editUser?.phoneNumber,
            "status": "ACTIVE"
        }
        const userId = localStorage.getItem("userId")
        axios({
            method: 'POST',
            url: lambda + "/addUser?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.result", response)
                    if (response?.data?.result === "User already exists" || response?.data?.result === "Emailid already exists") {
                        setIsLoading(false)
                        setExistMsg(true)

                    }
                    else if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        // setToastMessage("User Details Created Successfully")
                        // setTimeout(() => {
                        //     navigate("/users"); // Trigger API call AFTER toast is displayed
                        // }, 2000);
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        navigate("/fellowshiplist", { state: { restoreListPage: true } })
    }







    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <SideMenu />
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&

                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">{id === undefined ? "ADD USER" : "VIEW Fellowship"}</h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>Fellowship</span> / <b id="breadcrumb-action">{id === undefined ? "ADD USER" : "VIEW Fellowship"}</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="create-user-block" id="create-user-block">
                                    {Object.keys(editUser)?.length > 0 ? (
                                        <>
                                            <div className="form-block" id="form-block">
                                                <div className="row">

                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">NAME<span className="required">*</span></label>
                                                            <input id="name" name="name" placeholder="Enter Name" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)} value={editUser?.name} disabled />
                                                            <span id="name-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{nameError}</span>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">E-MAIL ID<span className="required">*</span></label>
                                                            <input id="email" name="emailid" placeholder="Enter Your Email" type="email" className="form-control" aria-invalid="false" value={editUser?.emailid} disabled={id !== undefined} onChange={(e) => handleChange(e)} />
                                                            <span id="email-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>
                                                        </div>

                                                    </div>

                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label">CONTACT NUMBER </label>
                                                            <div className="country-code">
                                                                {/* <select id="country-code" name="idc" value={editUser?.idc} className="colorselect capitalize" onChange={(e) => handleCountryChange(e)}>
                                            {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                                                return (
                                                                                    <><option key={i} value={task.alpha3}>{task.alpha3}{task.countrycode}</option></>
                                                                                )
                                                                            }
                                                                            )}
                                            </select> */}
                                                                <input
                                                                    id="contact-number"
                                                                    className="form-control contact-number"
                                                                    type="tel"
                                                                    name="phoneNumber"
                                                                    value={editUser?.phoneNumber}
                                                                    placeholder="Enter Phone Number"
                                                                    onChange={handleChange}
                                                                    disabled
                                                                    style={{ backgroundColor: "#e9ecef", }}
                                                                />

                                                                <span id="idc-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{IdcError}</span>
                                                                {/* <span id="phone-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{phoneError}</span> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label" htmlFor="usertype-select">
                                                                Assign Pathologist<span className="required">*</span>
                                                            </label>




                                                            <Select
                                                                isMulti={false}
                                                                // isDisabled={true}
                                                                value={selectedPathologist.length > 0 ? selectedPathologist : null}
                                                                options={
                                                                    Array.isArray(pathologist) && pathologist.length > 0
                                                                        ? pathologist
                                                                            .map((eachItem) => ({
                                                                                value: `${eachItem.userid}`,
                                                                                label: eachItem.name,
                                                                            }))
                                                                        : []
                                                                }
                                                                name="assignedPathologists"
                                                                onChange={handlePathologistChange}
                                                                placeholder="Select"
                                                                classNamePrefix="my-select"
                                                                isDisabled={true}

                                                            />
                                                            <span
                                                                id="usertype-error"
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                            >
                                                                {typeError}
                                                            </span>
                                                        </div>
                                                    </div>


                                                    {/* <div className="col-lg-6 col-md-12">
                                                        <div className="mb-3 input-field">
                                                            <label className="form_label" htmlFor="usertype-select">
                                                                Modules<span className="required">*</span>
                                                            </label>




                                                            <Select
                                                                isMulti
                                                                // isDisabled={true}
                                                                value={selectedModule}
                                                                options={
                                                                    Array.isArray(module) && module.length > 0
                                                                        ? module
                                                                            .map((eachItem) => ({
                                                                                value: `${eachItem.userid}`,
                                                                                label: eachItem.name,
                                                                            }))
                                                                        : []
                                                                }
                                                                name="modules"
                                                                onChange={handlemoduleChange}
                                                                placeholder="Select"
                                                                classNamePrefix="my-select"
                                                                isDisabled={true}

                                                            />
                                                            <span
                                                                id="usertype-error"
                                                                className="errormsg"
                                                                style={{ fontWeight: 'bold', color: 'red' }}
                                                            >
                                                                {typeError}
                                                            </span>
                                                        </div>
                                                    </div> */}


                                                    <div className="col-lg-6">
                                                        {id &&
                                                            <div className="col-lg-12 col-md-12">
                                                                <div className="mb-3 input-field">
                                                                    <label className="form_label" htmlFor="usertype-select">
                                                                        STATUS
                                                                    </label>
                                                                    <select
                                                                        id="usertype-select"
                                                                        className="colorselect capitalize form-control form-select"
                                                                        name="status"
                                                                        onChange={(e) => handleChange(e)}
                                                                        value={editUser?.status}
                                                                        disabled

                                                                    >
                                                                        <option value="" id="usertype-option-default">Select Type</option>
                                                                        <option value="ACTIVE" id="usertype-option-superadmin">ACTIVE</option>
                                                                        <option value="INACTIVE" id="usertype-option-superadmin">INACTIVE</option>
                                                                    </select>
                                                                    <span
                                                                        id="usertype-error"
                                                                        className="errormsg"
                                                                        style={{ fontWeight: 'bold', color: 'red' }}
                                                                    >
                                                                        {typeError}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>








                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    {/* <button id="submit-button" className="fill-btn-style create-quiz-btn border-0" type="submit" onClick={e => id === undefined ? handleAddUser(e) : handleUpdate(e)}>
                                                        {isLoading ? (<img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" alt="loading" />) : null}
                                                        {id === undefined ? "Create" : "Update"}
                                                    </button> */}
                                                </div>
                                                {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                            </div>
                                        </>
                                    ) : (
                                        <div className="form-block" id="loading-block">
                                            <div className="tab-content p-3 text-muted">
                                                <div className="tab-pane active show" id="home1" role="tabpanel">
                                                    <div className="row">
                                                        <Loader />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                }



            </div>
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <SweetAlert
                show={existmsg}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Email already exists"}
                onConfirm={e => setExistMsg(false)}
                id="error-alert"
            ></SweetAlert>
            <SweetAlert
                show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={id ? "User Details Updated Successfully" : "User created and Email sent successfully"}
                onConfirm={e => onConfirm()}
                id="error-alert"
            ></SweetAlert>



        </>
    );
};

export default ViewFellows;